<div class="page">
  <div class="page__content">
    <h1 class="header">{{ "step_postal_code.title" | translate }}</h1>
    <p>{{ "step_postal_code.text" | translate }}</p>
    <form>
      <custom-form-field
        (keydown.enter)="$event.preventDefault()"
        type="text"
        [label]="'step_postal_code.field_postal_code' | translate"
        controlName="postalCode"
        [formGroup]="postalCodeForm"
      >
      </custom-form-field>
      <button
        customButton
        appearance="text"
        expand="full"
        type="button"
        (click)="setPostalCodeFromCurrentLocation()"
        [disabled]="isGetPostalCodeLoading$ | async"
        [isLoading]="isGetPostalCodeLoading$ | async"
      >
        <svg-icon src="./assets/icons/navigation.svg"></svg-icon>
        <span>
          {{ "step_postal_code.button_current_location" | translate }}</span
        >
      </button>
    </form>
  </div>
  <div class="page__footer">
    <button
      customButton
      customOnboardingNext
      [disabled]="isLoading || postalCodeControl.invalid"
      expand="full"
      size="large"
      [isLoading]="isLoading"
    >
      {{ "step_postal_code.button_next" | translate }}
    </button>
  </div>
</div>
